import axios from "axios"
import {getStationCode} from "../../network/NetworkUtil";
import {
    convertMillisecondsToHHMM,
    formatAlias,
    getCluster,
    getDateInMMDDYYYYWithOffset,
    getLatestPicker, getRegion, isNotINRegionOrSSD,
    isNotSSDAndINRegion
} from "../../util/Util";
import {getDepartStatus, getRouteStatus, handleUnassignedRoutes,
NOT_READY, PARTIALLY_DEPARTED, DEPARTED, READY} from "../../util/EntityStatusManager";
import {getDispatchTime} from "../../stageStatus/network/StageNetworkAPI";
import {CORE_AMZL, MILLIS_IN_SECOND, REGION, TIMEOUTS, DEPART_TABLE_ACTIONS, OPERATION_TYPES} from "../../util/Constants";
import {
    DEPART_TAB_METRIC_KEY, ERROR_COUNT_METRIC, GLOBAL_METRIC_KEY,
    logErrorMetric,
    logOperationalMetric,
    MetricType, RSWS_UPDATE_ROUTE_STATUS_METRIC, SVS_ROUTE_DATA_METRIC,
    RSWS_ROUTE_LIST_METRIC,
    RSWS_BATCH_ROUTE_DETAILS_METRIC
} from "../../util/MetricUtil";
import {getRouteStagingLocation, transformStagingLocations} from "../../util/DataTransformUtil";
import {Logger} from "../../util/Logger";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {updateRouteToStowedInCacheOnReadyForDispatch} from "../../util/CacheManager";

/** Fetch Route List **/
export function fetchRouteInformation(args, capability) {
    args.stationConfig.amxl ? getAMXLRoutes(args, capability) : getRouteInformation(args, capability);
}

/** Bulk Updates Route Status to Ready For Dispatch **/
export function bulkUpdateRouteStatusToReadyForDispatch(args) {
    bulkUpdateRouteStatusToReadyForDispatchRequest(args);
}

/** Updates Route Status to Ready For Dispatch **/
export function  updateRouteStatusToReadyForDispatch(args) {
    updateRouteStatusToReadyForDispatchRequest(args);
}


async function getRouteInformation(args, capability) {
    const {dispatcher, filterDispatcher, baseUrl, xptNodes, configDispatch, stationConfig} = args;
    const startTime = Date.now();
    const stationCode = getStationCode();
    const metricKey = getRegion() === REGION.IN? DEPART_TAB_METRIC_KEY +"_" + REGION.IN
        : DEPART_TAB_METRIC_KEY;
    try {
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_GET_STATION_ROUTES_API_TIMEOUT
        });
        var response;
        if(stationConfig && stationConfig.authEnabled) {
            const requestPayload = getRouteRequestPayload(xptNodes);
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.get(getRouteRequestURL(xptNodes));
        }
        if (response && response.status === 200) {
            logOperationalMetric(startTime, stationCode, metricKey, RSWS_ROUTE_LIST_METRIC, MetricType.SUCCESS);
            const output = response.data.routes;
            const lastUpdated = new Date().getTime()
            dispatcher({
                type: "UPDATE_ROUTE_DATA_CACHE",
                data: {
                    record: {response: response.data, xptNodes: xptNodes, stationCode: stationCode},
                    lastUpdated: lastUpdated
                }
            });
            dispatcher({type: "RECEIVE_DATA",
                data: {...getRouteData(output, capability, stationConfig), lastUpdated: lastUpdated}
            });
            filterDispatcher({type: "RECEIVE_FILTER_DATA", data: getFilterData(output, capability)})
            configDispatch({
                type: 'RECEIVE_REFRESH_INTERVAL',
                data: {
                    refreshInterval:  response.data.routeRefreshRate
                }
            });
        } else {
            var error = {
                response : response
            }
            Logger.error("Exception in DepartNetworkAPI.getRouteInformation" , error);
            logOperationalMetric(startTime, stationCode, metricKey, RSWS_ROUTE_LIST_METRIC, MetricType.FAILED, error);
        }
    } catch (error) {
        Logger.error("Exception in DepartNetworkAPI.getRouteInformation", error);
        logOperationalMetric(startTime, stationCode, metricKey, RSWS_ROUTE_LIST_METRIC, MetricType.FAILED, error);
    }
}

function getRouteRequestPayload(xptNodes) {
    const mainUri = `/apigw/route/station/${getStationCode()}`;
    if (Array.isArray(xptNodes) && xptNodes.length) {
        const nodeList = [...xptNodes];
        const requestBody = {
            "date": [getDateInMMDDYYYYWithOffset(0)],
            "nodes": [nodeList.join(",")]
        }
        const requestPayload = {
            resourcePath: mainUri,
            httpMethod: "get",
            processName: "routeStaging",
            requestParams: requestBody
        }
        return requestPayload;
    } else {
        const requestBody = {
            "date": [getDateInMMDDYYYYWithOffset(0)]
        }
        const requestPayload = {
            resourcePath: mainUri,
            httpMethod: "get",
            processName: "routeStaging",
            requestParams: requestBody
        }
        return requestPayload;
    }
}

/** Batch get route information for give route code **/
async function batchGetRouteContent(routeIds, baseUrl, stationCode, stationConfig) {
    const startTime = Date.now();
    const metricKey = getRegion() === REGION.IN? DEPART_TAB_METRIC_KEY +"_" + REGION.IN
        : DEPART_TAB_METRIC_KEY;
    try {
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        const requestBody = {
            "date": getDateInMMDDYYYYWithOffset(0),
            "routeIds": routeIds
        };
        if(stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/stationCode/" + stationCode + "/routes-batch",
                httpMethod: "post",
                processName: "routeStaging",
                requestParams: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.post("/rsws/stationCode/" + stationCode + "/routes-batch", requestBody);
        }
        if (response && response.status === 200) {
            logOperationalMetric(startTime, stationCode, metricKey, RSWS_BATCH_ROUTE_DETAILS_METRIC, MetricType.SUCCESS);
            return response.data;
        } else {
            var error = {
                response : response
            }
            Logger.error("Exception in DepartNetworkAPI.batchGetRouteContent", error);
            logOperationalMetric(startTime, stationCode, metricKey, RSWS_BATCH_ROUTE_DETAILS_METRIC, MetricType.FAILED, error);
        }
    } catch (error) {
        Logger.error("Exception in DepartNetworkAPI.batchGetRouteContent", error);
        logOperationalMetric(startTime, stationCode, metricKey, RSWS_BATCH_ROUTE_DETAILS_METRIC, MetricType.FAILED, error);
    }
}

function getStowRouteAPIGatewayRequest(request) {
    return {
        resourcePath: "/svs/routes/data",
        httpMethod: "post",
        processName: "stow",
        requestBody: request
    }
}

function getAMXLDepartStatus(stowProgress, departProgress) {
    if (departProgress != null && (departProgress.completedCount === departProgress.totalCount
        && departProgress.completedCount > 0)) return DEPARTED;
    if (departProgress != null && 0 < departProgress.completedCount) return PARTIALLY_DEPARTED;
    if (stowProgress != null && (stowProgress.completedCount === stowProgress.totalCount
        && stowProgress.completedCount > 0)) return READY;
    return NOT_READY;
}

/**
 * Function to fetch Routes Information for AMXL Stations
 * @param args
 * @returns {Promise<void>}
 */
async function getAMXLRoutes(args, capability) {
    const {dispatcher, filterDispatcher, baseUrl, xptNodes, configDispatch, stationConfig} = args;
    const startTime = Date.now();
    const stationCode = getStationCode();
    const metricKey = getRegion() === REGION.IN? DEPART_TAB_METRIC_KEY +"_" + REGION.IN
            : DEPART_TAB_METRIC_KEY;
    const request = {
        filters: {
            NODE:[getStationCode()]
        },
        fieldsRequired: ["ID", "CODE", "PLANNED_COUNT", "CPT"]
    };
    try {
        const gatewayRequest = getStowRouteAPIGatewayRequest(request);
        const response = await getAPIGatewayDataFromParent(gatewayRequest);
        if (response.status === 200) {
            logOperationalMetric(startTime, stationCode, metricKey, SVS_ROUTE_DATA_METRIC, MetricType.SUCCESS);
            const routeIdToRouteMap = response.data.routes.reduce((a, v) => ({...a, [v.id]: v}), {})
            const routeIds = Object.keys(routeIdToRouteMap)

            const enrichedRouteInfo = await batchGetRouteContent(routeIds, baseUrl, stationCode, stationConfig);
            const routeIdToEnrichDataMap = enrichedRouteInfo ? enrichedRouteInfo.routes.reduce((a, v) => ({...a, [v.routeId]: v}), {}) : null;
            for (const routeId of routeIds) {
                routeIdToRouteMap[routeId].routeCode = routeIdToRouteMap[routeId].code;
                routeIdToRouteMap[routeId].routeId = routeIdToRouteMap[routeId].id;
                routeIdToRouteMap[routeId].stationCode = getStationCode();
                routeIdToRouteMap[routeId].type = routeIdToRouteMap[routeId].code.includes('_') ?
                      routeIdToRouteMap[routeId].code.split('_')[0] : routeIdToRouteMap[routeId].code.substring(0,2);
                routeIdToRouteMap[routeId].criticalPullTime = routeIdToRouteMap[routeId].cpt;

                //enrich containers, status and driver etc. information from RSWS
                if (routeIdToEnrichDataMap && routeId in routeIdToEnrichDataMap) {
                    routeIdToRouteMap[routeId].departProgress = routeIdToEnrichDataMap[routeId].departProgress;
                    routeIdToRouteMap[routeId].stowProgress = routeIdToEnrichDataMap[routeId].stowProgress;
                    routeIdToRouteMap[routeId].routeStatus = getAMXLDepartStatus(routeIdToEnrichDataMap[routeId].stowProgress,
                        routeIdToEnrichDataMap[routeId].departProgress);
                    routeIdToRouteMap[routeId].driver = routeIdToEnrichDataMap[routeId].driver;
                    routeIdToRouteMap[routeId].stagingLocation = routeIdToEnrichDataMap[routeId].stagingLocation;
                    routeIdToRouteMap[routeId].stagingLocations = routeIdToEnrichDataMap[routeId].stagingLocations;
                }
            }
            const amxlRoutes = Object.values(routeIdToRouteMap);

            const lastUpdated = new Date().getTime()
            response.data.routes = amxlRoutes;
            dispatcher({
                type: "UPDATE_ROUTE_DATA_CACHE",
                data: {
                    record: {response: response.data, xptNodes: xptNodes, stationCode: stationCode},
                    lastUpdated: lastUpdated
                }
            });
            dispatcher({type: "RECEIVE_DATA",
                data: {...getRouteData(amxlRoutes, capability, stationConfig), lastUpdated: lastUpdated}
            });
            filterDispatcher({type: "RECEIVE_FILTER_DATA", data: getFilterData(amxlRoutes, capability)})
            configDispatch({
                type: 'RECEIVE_REFRESH_INTERVAL',
                data: {
                    refreshInterval:  enrichedRouteInfo.routeRefreshRate
                }
            });
        }
    } catch(error) {
        Logger.error("Exception in DepartNetworkAPI.getAMXLRoutes", error);
        logOperationalMetric(startTime, stationCode, metricKey, SVS_ROUTE_DATA_METRIC, MetricType.FAILED, error);
    }
}

/**
 * Function to update RouteStatus
 * @param args
 * @returns {Promise<void>}
 */
async function updateRouteStatusToReadyForDispatchRequest(args) {
    const { dispatcher, routeId, baseUrl, stationConfig, additionalData } = args;
    const metricKey = DEPART_TAB_METRIC_KEY +"_" + REGION.IN
    const startTime = Date.now();
    const stationCode = getStationCode();
    try {
        const requestBody = {
            "stationCode": stationCode,
            "operationType": "ROUTE_READY_FOR_DISPATCH",
            "requestAttributes" : {
                "routeId": [routeId]
            }
        }
        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/execute-operation/",
                httpMethod: "post",
                processName: "routeStaging",
                requestBody: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.post("/rsws/execute-operation/", requestBody);
        }
        if(response.status === 200) {
            logOperationalMetric(startTime, stationCode, metricKey, RSWS_UPDATE_ROUTE_STATUS_METRIC, MetricType.SUCCESS);
            updateRouteToStowedInCacheOnReadyForDispatch(routeId);
            dispatcher({type: "LOAD_VIEW",
                data: additionalData
            });
            dispatcher({
                type: "SUCCESS_NOTIFICATION", data: {
                    alert: {title: "Route marked ready to Depart", type: "success"}
                }
            });
        }
        else {
            var error = {
                response : response
            }
            logOperationalMetric(startTime, stationCode, metricKey, RSWS_UPDATE_ROUTE_STATUS_METRIC, MetricType.FAILED, error);
            dispatcher({type: "FAILURE_NOTIFICATION", data:{
                    alert: {title: response.data.errorMessage, type: "error"}}
            });
        }
    } catch (error) {
        Logger.error("Exception in DepartNetworkAPI.updateRouteStatus", error);
        logOperationalMetric(startTime, stationCode, metricKey, RSWS_UPDATE_ROUTE_STATUS_METRIC, MetricType.FAILED, error);
        dispatcher({type: "FAILURE_NOTIFICATION", data:{
                alert: {title: error.message, type: "error"}}
        });
    }
}

/**
 * Function to update RouteStatus for multiple route ids - IN Bulk Depart
 * @param args
 * @returns {Promise<void>}
 */
async function bulkUpdateRouteStatusToReadyForDispatchRequest(args) {
    const {dispatcher, routeIds, baseUrl, stationConfig, additionalData } = args;

    let failureIds = [];
    let successIds = [];

    //Open Modal with Loading symbol for all routes
    updateBulkDepartModal(dispatcher, successIds, failureIds, routeIds);

    for (let key in routeIds) {
        let routeData = routeIds[key];
        let routeId = routeData.routeId;

        // Depart the route
        let response = await markRouteAsDeparted(routeId, baseUrl, stationConfig);

        if (response) {
            successIds.push(routeId);
        } else {
            failureIds.push(routeId);
        }

        // Update Route status
        updateBulkDepartModal(dispatcher, successIds, failureIds, routeIds);
    }

    // Reload view - after all are marked
    dispatcher({type: DEPART_TABLE_ACTIONS.LOAD_VIEW,
        data: additionalData
    });
}

/**
 * Fire a dispatcher to update bulk depart modal with success, failure ids
 * @param dispatcher DepartReducer
 * @param successIds List of successful routes
 * @param failureIds List of failed routes
 * @param routeIds List of all routes
 */
function updateBulkDepartModal(dispatcher, successIds, failureIds, routeIds) {
    dispatcher({
        type: DEPART_TABLE_ACTIONS.BULK_SUCCESS_NOTIFICATION_UPDATE, data: {
            bulkDepartStatus: {
                successIds: successIds,
                failureIds: failureIds,
                routeIds: routeIds
            }
        }
    });
}

/**
 * Makes an API request to mark the route as departed
 * @param routeId - Route Id to depart
 * @param baseUrl - Url for the endpoint
 * @param stationConfig - Station Configuration
*/
async function markRouteAsDeparted(routeId, baseUrl, stationConfig) {
    const metricKey = getRegion() === REGION.IN ? DEPART_TAB_METRIC_KEY + "_" + REGION.IN
        : DEPART_TAB_METRIC_KEY;
    const startTime = Date.now();
    const stationCode = getStationCode();
    let requestSuccess = false;

    try {
        let requestBody = {
            "stationCode": stationCode,
            "operationType": OPERATION_TYPES.ROUTE_READY_FOR_DISPATCH,
            "requestAttributes" : {
                "routeId": [routeId]
            }
        }

        const api = axios.create({
            baseURL: baseUrl,
            timeout: TIMEOUTS.RSWS_DEFAULT_API_TIMEOUT
        });

        // If auth is enabled - use api gateway else use post endpoint
        var response;
        if (stationConfig && stationConfig.authEnabled) {
            const requestPayload = {
                resourcePath: "/apigw/execute-operation/",
                httpMethod: "post",
                processName: "routeStaging",
                requestBody: requestBody
            }
            response = await getAPIGatewayDataFromParent(requestPayload);
        } else {
            response = await api.post("/rsws/execute-operation/", requestBody);
        }

        if (response.status === 200) {
            logOperationalMetric(startTime, stationCode, metricKey, RSWS_UPDATE_ROUTE_STATUS_METRIC, MetricType.SUCCESS);
            updateRouteToStowedInCacheOnReadyForDispatch(routeId);
            requestSuccess = true;
        } else {
            var error = {
                response : response
            }
            logOperationalMetric(startTime, stationCode, metricKey, RSWS_UPDATE_ROUTE_STATUS_METRIC, MetricType.FAILED, error);
        }
    } catch (error) {
        Logger.error("Exception in DepartNetworkAPI.updateRouteStatus", error);
        logOperationalMetric(startTime, stationCode, metricKey, RSWS_UPDATE_ROUTE_STATUS_METRIC, MetricType.FAILED, error);
    }

    return requestSuccess;
}

function getRouteRequestURL(xptNodes) {
    const mainUri = `/rsws/route/station/${getStationCode()}?date=${getDateInMMDDYYYYWithOffset(0)}`;
    if (Array.isArray(xptNodes) && xptNodes.length) {
        const nodeList = [...xptNodes];
        return `${mainUri}&nodes=${nodeList.join(",")}`;
    } else {
        return mainUri;
    }
}

export function getRouteData(output, capability, stationConfig) {
    const model = {
        totalRoute: output.length,
        partialDepartedRoutes: 0,
        departedRoutes: 0,
        routeList: []
    }
    output = handleUnassignedRoutes(CORE_AMZL, output);
    output.forEach(route => {
        switch (route.routeStatus) {
            case "Departed":
                model.departedRoutes++; break;
            case "Departed (partial)":
                model.partialDepartedRoutes++; break;
            default:
                break;
        }
        try {
            route.criticalPullTime = getDispatchTime(route, CORE_AMZL);
            route.stagingLocations = transformStagingLocations(route);
            const routeDetail = {
                routeId: route.routeId,
                routeCode: route.routeCode,
                routeType: route.type,
                stationCode: route.stationCode,
                routeSLA: convertMillisecondsToHHMM(route.criticalPullTime),
                routeStatus: getRouteStatus(route, stationConfig),
                status: getDepartStatus(route, capability),
                hazmatWeight: route.hazmatWeight ? route.hazmatWeight : "...",
                departProgress: getDepartProgress(route, capability),
                stagingLocations: route.stagingLocations,
                stagingLocation: getRouteStagingLocation(route),
                picker: formatAlias(getLatestPicker(CORE_AMZL, route)),
                driver: route.driver && route.driver.name ? route.driver.name : "...",
                totalCarts: route.carts ? route.carts.length : 0,
                departByTime: route.plannedDispatchTime
                    ? getDepartByTime(route.plannedDispatchTime, capability)
                    : "...",
                stowProgress: getStowProgress(route, capability),
                topOffPackageCount: route.topOffPackageCount
                    ? route.topOffPackageCount : 0,
                sectorCodes: route.sectorCodes ?
                    route.sectorCodes.join(', '): ''
            }
            model.routeList.push(routeDetail)
        } catch (e) {
            Logger.error("Exception in DepartNetworkAPI.getRouteData", e);
            const metricKey = getRegion() === REGION.IN? GLOBAL_METRIC_KEY+"_"+REGION.IN
                : GLOBAL_METRIC_KEY;

            logErrorMetric(getStationCode(), metricKey, ERROR_COUNT_METRIC);

        }
    })
    return model
}

function getDepartByTime(plannedDispatchTime, capability) {
    return (typeof plannedDispatchTime === "number") && (isNotSSDAndINRegion(capability))
        ? convertMillisecondsToHHMM(plannedDispatchTime * MILLIS_IN_SECOND)
        : convertMillisecondsToHHMM(plannedDispatchTime)
}

/**
 * method to get DepartProgress
 * @param route
 * @param capability
 * @returns {string|string}
 */

function getDepartProgress(route, capability) {
    if(isNotSSDAndINRegion(capability)) {
        return route.departProgress;
    }
    return route.departProgress ? route.departProgress.completedCount + "/" + route.departProgress.totalCount : "0/0";
}

function getStowProgress(route, capability) {
    if(isNotINRegionOrSSD(capability)) {
        return route.stowProgress;
    }
    return route.stowProgress.completedCount + "/" + route.stowProgress.totalCount;
}

export function getFilterData(output, capability) {
    const data = {
        departure: new Set(),
        driverType: new Set(["DSP", "DP"]),
        cluster: new Set(),
        departByTime: new Set()
    }
    output.forEach(route => {
        if (route.type !== "...") {
            data.driverType.add(route.type)
        }
        data.cluster.add(getCluster(route.routeCode));
        if (route.criticalPullTime != null) {
             data.departure.add(convertMillisecondsToHHMM(route.criticalPullTime));
         }
        if((isNotSSDAndINRegion(capability)) && route.plannedDispatchTime !== "..." && (typeof route.plannedDispatchTime === "number")) {
           data.departByTime.add(convertMillisecondsToHHMM(route.plannedDispatchTime * MILLIS_IN_SECOND));
         }
    })
    return data;

}


// WEBPACK FOOTER //
// ./src/components/depart/network/DepartNetworkAPI.js